module.exports = __webpack_public_path__ + "7ac5cc5c983590fd8abad47db66d0003.MP3";